import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=eed28174&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=eed28174&prod&lang=scss&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=eed28174&prod&lang=scss"
import style2 from "./detail.vue?vue&type=style&index=2&id=eed28174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed28174",
  null
  
)

export default component.exports